// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Ghana */
const GH = /^(?:(?:2(?:[0346-9]\d|5[67])|5(?:[03-7]\d|9[1-9]))\d{6})$/;

export default GH;
